import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Form,
  Button,
} from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

// import { Switch } from "antd";

import SmartSelect from '../../../../components/select/SmartSelect.tsx';

// Auth
// import { useAuthContext } from '../../../../auth/use-auth-context.js';
// import { useRouter } from '../../../../auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { useFormikContext, fields } from './slice.tsx';
import defaultLocationFormSlice from '../../../manage/jobs/jobTypes/form/defaultLocation/slice.tsx';

import Map from './Map.tsx';

import DefaultLocationForm from '../../../manage/jobs/jobTypes/form/defaultLocation/Form.tsx';

// enums
import { getMaxPageSize, convertLatLngToCoord } from '../../../../utils/utils.tsx';
// import {  } from '../../../../utils/enums.tsx';

// components
// import MainContainer from '../../../../components/container/MainContainer.jsx';

import { ReactComponent as PlusIcon } from "../../../../../v5/assets/icons/plus.svg";

// ----------------------------------------------------------------------


const Tab = () => {
  // const location = useLocation();
  // const router = useRouter();
  
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  // const { isLoading } = useTypedSelector((state: RootState) => state.jobFormDefaultLocationFormSlice);
  const dispatch = useDispatch<AppDispatch>();


  const setFormElements = () => {
    return <Row className='g-8 mt-6'>
      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label>{fields.locationName.label}</Form.Label>
          <Form.Control
            as={SmartSelect}
            isInvalid={!!(errors && errors.defaultLocationId)}
            value={values.defaultLocationId}
            placeholder={fields.locationName.placeholder1}

            size='sm'
            getPopupContainer={(trigger: any) => trigger.parentNode}

            addText={'Add new location'}
            apiPath={'default-location'}
            customParams={{
              currentPage: 1,
              pageSize: getMaxPageSize(),
              sortColumn: 'locationName',
              sortDir: 'asc',
            }}
            fieldNames={{ value: 'defaultLocationId', label: 'locationName' }}
            selected={{ defaultLocationId: values.defaultLocationId, locationName: values?.defaultLocation?.locationName }}

            footerRender={(isLoading: boolean, ref: any) => {
              return <Button
                variant={'custom-text'}
                size={'sm'}
                disabled={isLoading}
                onClick={(e) => { 
                  e.preventDefault();
                  e.stopPropagation();

                  dispatch(defaultLocationFormSlice.setShow({ show: true, index: 0, id: null }));
                }}
              ><PlusIcon style={{ position: 'relative', top: '-1px' }} /> Add Default Location</Button>
            }}

            hasOptionRender={false}
            hasFooterRender={true}
            searchable={true}
            allowClear={true}
            selectedIcon={true}
            disabled={false}
            virtual={true}

            onChangeValue={async (value: any, option: any, ref: any) => {
              if(option){
                await setFieldValue('defaultLocationId', value);
                await setFieldValue('defaultLocation', option);
                await setFieldValue('locationName', option?.locationName);
                await setFieldValue('address', option?.address);
                await setFieldValue('addressField', option?.address);
                await setFieldValue('latitude', option?.latitude);
                await setFieldValue('longitude', option?.longitude);

                let coordinates = convertLatLngToCoord(option?.latitude, option?.longitude);
                await setFieldValue('coordinates', coordinates);

              } else {
                await setFieldValue('defaultLocationId', null);
                await setFieldValue('defaultLocation', null);
                await setFieldValue('locationName', '');
                await setFieldValue('address', '');
                await setFieldValue('addressField', '');
                await setFieldValue('latitude', '');
                await setFieldValue('longitude', '');
                await setFieldValue('coordinates', '');
              }
            }}
          />
          <Form.Control.Feedback type="invalid">{(errors && errors.defaultLocationId) && errors.defaultLocationId}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col xs={12} md={8}>
        <Form.Group>
          <Form.Label disabled={false}>{fields.address.label}</Form.Label>
          <Form.Control
            type={'text'}
            autoComplete='off'
            size='sm'
            placeholder={fields.address.placeholder1}
            disabled={true}
            value={values.address || ''}
            onChange={async (e) => {
              
            }}
            isInvalid={false}
          />
        </Form.Group>
      </Col>
      {(values?.coordinates != undefined && values?.coordinates != '') && <Col xs={12}>
        <Map 
          coordinates={values.coordinates}
          canMoveMarker={true}
          onDragEnd={(position: any) => {
            let coordinates = convertLatLngToCoord(position?.lat, position?.lng);

            setFieldValue('latitude', position?.lat);
            setFieldValue('longitude', position?.lng);
            setFieldValue('coordinates', coordinates);
          }}
        />
      </Col>}
    </Row>
  }


  return <>
    {setFormElements()}

    <DefaultLocationForm
      onCreate={async (index: any, data: any) => {
        await setFieldValue('defaultLocationId', data?.defaultLocationId);
        await setFieldValue('defaultLocation', data);
        await setFieldValue('locationName', data?.locationName);
        await setFieldValue('address', data?.address);
        await setFieldValue('addressField', data?.address);
        await setFieldValue('latitude', data?.latitude);
        await setFieldValue('longitude', data?.longitude);

        let coordinates = convertLatLngToCoord(data?.latitude, data?.longitude);
        await setFieldValue('coordinates', coordinates);
      }}
    />
  </>
}

export default Tab;
